module.exports = __webpack_public_path__ + "prod/1.42.2/img/power1.a4322e67.png";